import { useCallback, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Search } from "lucide-react";
import { api } from "@/lib/api";

export const usePaged = (url, limit = 25, extra = {}) => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(extra);
  const load = useCallback(() => {
    setLoading(true);
    return api.get(url, { params: { page, limit, search, ...JSON.parse(key) } })
      .then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [url, page, limit, search, key]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [search, key]);
  return { ...data, page, setPage, search, setSearch, load, loading, pages: Math.max(1, Math.ceil(data.total / limit)) };
};

export const SearchBox = ({ value, onChange, placeholder, testid }) => {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => onChange(v), 350); return () => clearTimeout(t); }, [v]); // eslint-disable-line
  return (
    <div className="flex items-center bg-[#241611] border border-[#3B251D] rounded-full px-3 h-10 w-full sm:w-72">
      <Search size={15} className="text-[#8C7B6E]" />
      <input data-testid={testid} value={v} onChange={(e) => setV(e.target.value)} placeholder={placeholder}
        className="bg-transparent outline-none text-sm text-[#FDFBF7] placeholder:text-[#8C7B6E] ml-2 w-full" />
    </div>
  );
};

export const Pager = ({ p, testid }) => (
  <div className="flex items-center justify-between mt-4 text-sm text-[#8C7B6E]" data-testid={testid}>
    <span>{p.total} total · page {p.page} of {p.pages}</span>
    <div className="flex gap-2">
      <button data-testid={`${testid}-prev`} disabled={p.page <= 1 || p.loading} onClick={() => p.setPage(p.page - 1)}
        className="h-9 w-9 rounded-full border border-[#3B251D] flex items-center justify-center disabled:opacity-30 hover:border-[#D4AF37]"><ChevronLeft size={16} /></button>
      <button data-testid={`${testid}-next`} disabled={p.page >= p.pages || p.loading} onClick={() => p.setPage(p.page + 1)}
        className="h-9 w-9 rounded-full border border-[#3B251D] flex items-center justify-center disabled:opacity-30 hover:border-[#D4AF37]"><ChevronRight size={16} /></button>
    </div>
  </div>
);
